import { render } from "./CropSizeEarningWeekly.vue?vue&type=template&id=0c36ae3a"
import script from "./CropSizeEarningWeekly.vue?vue&type=script&lang=js"
export * from "./CropSizeEarningWeekly.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__